/**
 * Page to display search results from Home page
 * /search
 */

import React, { useEffect, useMemo, useState } from 'react'
import { Col, Container, Form, Row } from 'react-bootstrap'
import {
  Footer,
  KonektoNavbar,
  Loader,
  PaginationList,
  Product,
  SearchFilters,
} from '../../components'
import '../../../src/App.scss'
import './Search.scss'
import { useLocation, useNavigate } from 'react-router-dom'
import { hasValue } from '../../helpers'
import { productService } from '../../services/productService'
import { IoMdSearch } from 'react-icons/io'

export default function Search() {
  const navigate = useNavigate()
  const location = useLocation()

  const queryParams = new URLSearchParams(location.search)
  const currentPage = queryParams.get('page') || 1
  const qParam = queryParams.get('q', '')
  const city = queryParams.get('grad') || ''

  const [products, setProducts] = useState([]) // full list or search result

  const [loader, setLoader] = useState(false)
  const [totalPages, setTotalPages] = useState(1)

  const [searchTerm, setSearchTerm] = useState(qParam)

  const getProducts = async ({ page, search, city }) => {
    setLoader(true)

    const response = await productService.searchProducts({
      page,
      search,
      city,
    })

    if (response.isOk && response.data) {
      setTotalPages(response.data.last_page)
      setProducts(response.data.data)
    }

    setLoader(false)
  }

  const handlePageChange = newPage => {
    queryParams.set('page', newPage)
    navigate(`?${queryParams.toString()}`)
    window.scrollTo({ top: 70, behavior: 'smooth' })
  }

  const emptyListMessage = useMemo(() => {
    if (products.length > 0) {
      return ''
    }

    if (hasValue(qParam)) {
      return `Nema rezultata za "${qParam}"`
    } else {
      return 'Vaša lista proizvoda je prazna'
    }
  }, [products, qParam])

  const onCardClick = product => {
    navigate(`/firma/${product.company_id}?p=${product.id}`)
  }

  const onSearchSubmit = e => {
    e.preventDefault()

    if (!hasValue(searchTerm) || searchTerm === qParam) {
      return
    }

    queryParams.set('q', searchTerm)
    navigate(`?${queryParams.toString()}`)
    window.scrollTo({ top: 100, behavior: 'smooth' })
  }

  useEffect(() => {
    getProducts({ page: currentPage, search: qParam, city })
  }, [qParam, city, currentPage])

  return (
    <div id="search">
      <KonektoNavbar />
      <Container className="mt-5">
        <div className="d-flex flex-column flex-sm-row mt-1">
          <div className="filters">
            <div>
              <Form onSubmit={onSearchSubmit} className=" position-relative">
                <input
                  maxLength={60}
                  minLength={3}
                  type="text"
                  className="form-control"
                  placeholder="Pretraži ime proizvoda"
                  aria-label="Pretraga"
                  onChange={e => {
                    setSearchTerm(e.target.value)
                  }}
                  value={searchTerm}
                />

                <IoMdSearch onClick={onSearchSubmit} className="search-icon" />
              </Form>
            </div>

            <SearchFilters />
          </div>

          <div className="products-list">
            <div className="group-wrapper mt-0">
              <Row>
                {products?.map(product => {
                  return (
                    <Col
                      className="mb-4"
                      key={product.id}
                      xs={12}
                      sm={6}
                      md={4}
                      lg={3}>
                      <Product
                        product={product}
                        onCardClick={() => onCardClick(product)}
                      />
                    </Col>
                  )
                })}
              </Row>

              {loader ? <Loader /> : null}
              {products?.length === 0 && !loader ? (
                <p className="text-center mt-4 warning-text">
                  {emptyListMessage}
                </p>
              ) : null}

              {totalPages > 1 ? (
                <PaginationList
                  currentPage={currentPage}
                  handlePageChange={handlePageChange}
                  totalPages={totalPages}
                />
              ) : null}
            </div>
          </div>
        </div>
      </Container>
      <Footer />
    </div>
  )
}
